export enum SignalRMessageTypeEnum {
  ReceiveMembersCSVFile = 'ReceiveMembersCSVFile',
  ReceiveAddressLabelsPDFFile = 'ReceiveAddressLabelsPDFFile',
  ReceiveBookKeepingXLSXFile = 'ReceiveBookKeepingXLSXFile',
  ReceiveBookKeepingSIEFile = 'ReceiveBookKeepingSIEFile',
  ReceiveMemberListPDFFile = 'ReceiveMemberListPDFFile',
  ReceiveAutogiroMandateFile = 'ReceiveAutogiroMandateFile',
  CreateMemberInvoicesDone = 'CreateMemberInvoicesDone',
  SendSendingsByMissionIdDone = 'SendSendingsByMissionIdDone',
  ReceiveSnapshotCSVFile = 'ReceiveSnapshotCSVFile',
  CreateInvoiceRemindersDone = 'CreateInvoiceRemindersDone',
  ReceiveDepositsCSVFile = 'ReceiveDepositsCSVFile',
}
